import { config } from "../config";

export const checkoutUri = config.checkout.url;
export const x2CheckoutUri = config.checkout.x2Url ?? checkoutUri;
